var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showOverlay)?_c('div',{staticClass:"fm-overlay"}):_vm._e(),_c('TheNavbar',{on:{"toggle-overlay":function (e) { return _vm.showOverlay = e; }}}),_c('main',[_c('TheHero')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }